import React, { useContext } from "react";
import { AuthContext } from "../context/auth-context";
import Message from "../Message";
import { CartContext } from "../context/cart-context";
import EmptyCart from "./EmptyCart";
import CartList from "./CartList";

const Cart = () => {
  const auth = useContext(AuthContext);
  const cart = useContext(CartContext);

  return (
    <React.Fragment>
      {!auth.isLoggedIn && <Message item="cart" />}
      {auth.isLoggedIn &&
        (cart.cart.length === 0 ? <EmptyCart /> : <CartList />)}
    </React.Fragment>
  );
};

export default Cart;
